<template>
  <tr>
    <td class="center aligned" style="min-width:140px">
      <div class="ui checkbox" style="margin-left:10px">
        <input type="checkbox" data-lpignore="true" v-model="value" name="dnt" :indeterminate.prop="indeterminate" v-on:click="cycleState()" />
        <label></label>
      </div>
      <br>
      <div v-if="this.state === 'ignored' || (this.state === 'ignoredUntilFirstSale' && !automaticallyTrackNewProducts)" class="ui tiny label">Ignored</div>
      <div v-else-if="this.state === 'ignoredUntilFirstSale'" class="ui tiny label">Ignored until next order</div>
      <div v-else>&nbsp;</div>
    </td>
    <td class="product-settings-image-cell">
      <i v-bind:class="product.marketplaceIso31662Code + ' flag'"></i>
      <a v-bind:href="product.productPage" target="_blank" rel="noopener noreferrer" class="product-settings-image-link">
        <img class="product-settings-row-thumb" v-bind:src="product.imageUrl" :alt="product.productName || ''" />
        <br /><small>[{{product.asin1}}]</small>
      </a>
    </td>
    <td>{{product.productName}} <br /><br />
      <div class="ui input">
        <input type="text" data-lpignore="true" v-model="shortName" size="40" style="margin-left:-15px;" />
      </div>
      <div class="ui tiny left pointing label">
        Short-hand name
      </div>
    </td>
  </tr>
</template>

<script>
export default {
  data: function () {
    return {
      shortName: this.product.shortName,
      indeterminate: this.product.active === null && !this.product.showOrig,
      value: !this.product.showOrig,
      state: (this.product.active === null && !this.product.showOrig ? 'ignoredUntilFirstSale' : (this.product.showOrig ? 'tracked' : 'ignored'))
    }
  },
  props: ['product', 'automaticallyTrackNewProducts'],
  watch: {
    shortName: function (val) {
      this.$emit('shortName-changed', {productId: this.product.productId, shortName: val})
    },
    state: function (val) {
      if (this.state === 'ignoredUntilFirstSale') {
        this.value = true
        this.indeterminate = true
        this.$emit('show-changed', {productId: this.product.productId, show: null})
      } else {
        const val = this.state === 'tracked'
        this.value = !val
        this.indeterminate = false
        this.$emit('show-changed', {productId: this.product.productId, show: val})
      }
    },
  },
  methods: {
    cycleState: function () {
      if (this.state === 'ignoredUntilFirstSale') {
        this.state = 'tracked'
      } else if (this.state === 'ignored') {
        this.state = 'ignoredUntilFirstSale'
      } else {
        this.state = 'ignored'
      }
    }
  },
}
</script>
<style type="text/css">
#prodSettBG .product-settings-image-cell {
  position: relative;
  vertical-align: top;
  width: 1%;
  max-width: 120px;
}

#prodSettBG .product-settings-image-link {
  display: inline-block;
  max-width: 100%;
  padding-top: 2px;
}

#prodSettBG .product-settings-row-thumb {
  max-width: 96px;
  max-height: 96px;
  width: auto;
  height: auto;
  object-fit: contain;
  display: block;
  border-radius: 4px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.12);
}

#prodSettBG .ui.table .flag {
  padding: 0 23px 18px 0;
  background-color: #fff;
}

#prodSettBG .product-settings-image-cell .flag {
  position: absolute;
  top: 0;
  left: 0;
  z-index: 1;
}

</style>



// WEBPACK FOOTER //
// ProductSettingsPage.ProductRow.vue?3b4b822e